import React from 'react';

export const serviceCashMovementNoSealConfig = [
  {
    path: '/service-cash-movement-noseal',
    component: React.lazy(() => import('./listing/listing')),
  },
  {
    path: '/service-cash-movement-noseal/rincian-noseal',
    component: React.lazy(() => import('./rincianNoSeal/rincianNoSeal')),
  },
  {
    path: '/service-cash-movement-noseal/overview-rincian-noseal',
    component: React.lazy(() =>
      import('./overviewRincianNoSeal/overviewRincianNoSeal'),
    ),
  },
  {
    path: '/service-cash-movement-noseal/cpc-repair-noseal',
    component: React.lazy(() =>
      import('./repairNoSealCashMovement/repairNoSealCashMovement'),
    ),
  },
  {
    path: '/service-cash-movement-noseal/overview-cpc-repair-noseal',
    component: React.lazy(() =>
      import(
        './overviewRepairNoSealCashMovement/overviewRepairNoSealCashMovement'
      ),
    ),
  },
];
